export enum AliasesAPI {
    createAliasBinding = "AliasBindings.CreateAliasBinding",
    getAliasBindings = "AliasBindings.GetAliasBindings",
    getPublicAliasBinding = "AliasBindings.GetPublicAliasBinding",
    updateAliasBinding = "AliasBindings.UpdateAliasBinding",
    getAliasesByMenuId = "AliasBindings.GetMenuAliasBindings"
}
